import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import shouldEventBeListedOnArchive from '../../misc/shouldEventBeListedOnArchive';
import Blocklink from '../elements/Blocklink';
import ContainedImage from '../elements/ContainedImage';
import Grid from '../elements/Grid';
import Hint from '../elements/Hint';
import CommunityIcon from '../elements/icons/CommunityIcon';
import EventIcon from '../elements/icons/EventIcon';
import Link from '../elements/Link';
import {UnreadNotificationsBubble} from '../elements/NotificationsBubble';
import Scrollable from '../elements/Scrollable';
import InsceneSocialMenu from '../elements/SocialMenu/InsceneSocialMenu';
import TopBar from '../elements/TopBar/TopBar';
import WaitWhileBusy from '../WaitWhileBusy';
import Screen from './Screen';

class MainScreen extends React.Component {
    render() {
        var i18n = this.props.i18n;

        var communities = _(this.props.communities)
            .values()
            .sortBy(event => {
                return event._local.start.valueOf();
            })
            .map(function (community) {
                return (
                    <Link className="eventIcon" href={['/events', community.id].join('/')} key={community.id}>
                        <CommunityIcon {...community} />
                    </Link>
                );
            })
            .value();
        if (communities.length) {
            communities = (
                <div className="communities">
                    <h1 className="none" style={{marginTop: 0}}>
                        {i18n['label.my.communities']}
                    </h1>
                    <Grid className="valignTop" columns={5} useEndPadding="useEndPadding">
                        {communities}
                    </Grid>
                </div>
            );
            // <Slider slidesToShow={4} touchMove={true} infinite={false} cssEase="ease-out">
            //     {communities}
            // </Slider>
        }

        var events = _(this.props.events)
            .values()
            .sortBy(event => {
                return event._local.start.valueOf();
            })
            .map(function (event) {
                return (
                    <Link className="eventIcon" href={['/events', event.id].join('/')} key={event.id}>
                        <EventIcon event={event} />
                    </Link>
                );
            })
            .value();
        if (this.props.archived.length) {
            events.unshift(
                <Link className="eventIcon" href="./archive" key="archive">
                    <div>
                        <div className="icon archive" />
                        <div className="name">{i18n['label.archived-events']}</div>
                        <div />
                    </div>
                </Link>
            );
        }
        if (events.length) {
            events = (
                <div className="events">
                    <h1 className="none">{i18n['label.my.events']}</h1>
                    <Grid className="valignTop" columns={5} useEndPadding="useEndPadding">
                        {events}
                    </Grid>
                </div>
            );
            // <Slider slidesToShow={4} touchMove={true} infinite={false} cssEase="ease-out">
            //     {events}
            // </Slider>
        }

        var emptyList;
        if (!_.values(this.props.events).length && !_.values(this.props.communities).length) {
            emptyList = <Hint className="newCode">{i18n['hint.add-event']}</Hint>;
        }

        let header = (
                <div>
                    <TopBar showLogo="showLogo" />
                    <hr />
                    <Link className="profile" href="/my_profile">
                        <div className="logo" />
                        <div className="icon">
                            <ContainedImage src={this.props.avatar} />
                            <div className="label">{i18n['label.my.profile']}</div>
                        </div>
                    </Link>
                    <div className="tabs">
                        <Link className="notifications" href="/notifications">
                            {i18n['label.Notifications']}
                            <UnreadNotificationsBubble />
                        </Link>
                        <Link className="contacts" href="/contacts">
                            {i18n['label.my.contacts']}
                        </Link>
                        <Link className="newCode" href="/add">
                            {i18n['label.new.eventcode']}
                        </Link>
                    </div>
                    <hr />
                </div>
            ),
            footer = (
                <div>
                    <Blocklink color="none" href="/get_most" next="next">
                        {i18n['label.about.netwerkapp']}
                    </Blocklink>
                    <InsceneSocialMenu />
                </div>
            );

        return (
            <Screen className="main" header={header} footer={footer}>
                <Scrollable>
                    {communities}
                    {events}
                    {emptyList}
                </Scrollable>
            </Screen>
        );
    }
}

const ConnectedScreen = connect(function (state, props) {
    let events = _(state.events).values().map('event').filter({_isEvent: true}).filter({joined: true}).value();

    return {
        i18n: state.i18n.translations,
        avatar: state.session.user.image_url,
        events: _(events).reject(shouldEventBeListedOnArchive).value(),
        archived: _(events).filter(shouldEventBeListedOnArchive).value(),
        communities: _(state.events).values().map('event').filter({_isCommunity: true}).value(),
    };
})(MainScreen);

export default props => (
    <WaitWhileBusy>
        <ConnectedScreen {...props.match.params} />
    </WaitWhileBusy>
);
